import { useQuery } from '@apollo/client';
import { useResource } from '@landsbankinn/l16n';
import { useEffect } from 'react';
import {
  OperationalStatusComponentId,
  OperationalStatusEnum,
} from '../../../gql/__generated__/graphql';
import { GET_OPERATIONAL_STATUS } from '../../../gql/operationalStatus';
import { getLocaleToLanguage } from '../utils';

export const useFetchOperationalStatus = (
  component: OperationalStatusComponentId,
  statuses?: OperationalStatusEnum[],
) => {
  const { locale } = useResource();
  const { loading, refetch, data } = useQuery(GET_OPERATIONAL_STATUS, {
    variables: {
      filter: { components: [component], status: statuses },
    },
    context: {
      headers: {
        'Accept-Language': getLocaleToLanguage(locale),
      },
    },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    refetch();
  }, [locale, refetch]);

  const operationalStatus =
    data?.operationalStatus && data.operationalStatus.length > 0
      ? data.operationalStatus[0]
      : null;
  return { operationalStatus: operationalStatus, loading };
};
